const phoneSystemReportingConfiguration = {
  uuid: {
    label: "Uuid",
  },
  fqdn: {
    label: "FQDN",
  },
  server: {
    label: "Serveur (@IP)",
  },
  port: {
    label: "Port",
  },
  user: {
    label: "Utilisateur 3CX",
  },
  password: {
    label: "Mot de passe 3CX",
  },
  active: {
    label: "Activer les rapports ?",
  }
};

export default phoneSystemReportingConfiguration;
